import axios from '@/config/httpConfig'

//上传图片文件
export function uploadImg(data) {
  return axios.post('/file/uploadImg', data)
}
